<!--
 * @Author: 🐝
 * @Date: 2023-12-04 16:45:50
 * @LastEditors: Ant🐜
 * @LastEditTime: 2023-12-15 09:56:46
 * @Description: 描述一下
-->
<template>
  <div v-if="state.apply_status !== null" class="status-wrap">
    <img :src="info[state.apply_status]?.i" alt="" />
    <h1>{{ info[state.apply_status]?.t }}</h1>
    <span>{{ info[state.apply_status]?.d + ([2, 4].includes(state.apply_status) ? state.audit_remark : '') }}</span>
    <div style="visibility: hidden" class="store-wrap">
      <div class="label">已绑定店铺</div>
      <div class="cell-value">
        <span v-for="(item, index) in state.storeList"> {{ item }}{{ index < 4 ? '、' : '' }} </span>
      </div>
    </div>
    <van-button
      v-if="state.apply_status === 1"
      class="btn"
      type="primary"
      @click="push('/bindSharer?sharer_id=' + state.sharer_id)"
      >去绑定</van-button
    >
    <van-button v-else-if="[2, 4].includes(state.apply_status)" class="btn" type="primary" @click="emits('handlApply')"
      >重新申请</van-button
    >
    <van-button v-else class="btn" type="primary" @click="switchTabMain">返回首页</van-button>
  </div>
</template>
<script setup>
import { ref } from 'vue'
import status0 from '@/assets/img/applySharer_ready.png'
import status1 from '@/assets/img/applySharer_success.png'
import status2 from '@/assets/img/applySharer_fail.png'
import status3 from '@/assets/img/applySharer_bind.png'
import status4 from '@/assets/img/applySharer_bind_fail.png'
import usePage from '@/hooks/usePage'
import { useRouter } from 'vue-router'

const { push } = useRouter()
const props = defineProps({ state: Object })
const emits = defineEmits(['handlApply'])
const info = ref({
  0: { i: status0, t: '审核中', d: '审核中，请耐心等待哦~' },
  1: { i: status1, t: '审核成功', d: '恭喜您！审核已通过，请尽快去绑定分享员哦！' },
  2: { i: status2, t: '审核未通过', d: '拒绝原因：' },
  3: { i: status3, t: '绑定成功', d: '您已经是分享员啦，快前往视频号分享商品吧~' },
  4: { i: status4, t: '绑定失败', d: '' }
})
const { switchTabMain } = usePage()
</script>
<style lang="less" scoped>
.status-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 16px;

  img {
    margin-top: 80px;
    width: 160px;
  }

  h1 {
    font-size: 22px;
    font-weight: bold;
    color: #353f72;
  }

  span {
    font-size: 14px;
    color: #8188aa;
  }

  .store-wrap {
    margin-top: 40px;
    padding: 16px 12px;
    display: flex;
    color: #8188aa;
    font-size: 12px;
    width: 311px;
    height: 72px;
    background: #f6f6f6;
    border-radius: 8px;

    .label {
      color: #c8c8c8;
      flex-shrink: 0;
    }

    .cell-value {
      margin-left: auto;
      padding-left: 10px;
      display: flex;
      flex-wrap: wrap;

      span {
        font-size: 12px;
      }
    }
  }

  .btn {
    margin-top: 40px;
    width: 311px;
    height: 48px;
    background: #4d7fec;
    border-radius: 8px;
    border: #4d7fec;
  }
}
</style>
